

exports.__esModule = true;

var _route = require('./route');

Object.keys(_route).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _route[key];
    }
  });
});

var _directive = require('./directive');

Object.keys(_directive).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _directive[key];
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./pages/xo-gambling-block-cool-off-period/index.js
// module id = ./pages/xo-gambling-block-cool-off-period/index.js
// module chunks = 0